import React, { useState, useEffect } from 'react';
import logo from '../logolumi.png';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <a href="#hero" className="navbar__logo">
          <img src={logo} alt="LumiMind" className="navbar__logo-img" />
          <span className="navbar__logo-text">LumiMind</span>
        </a>

        <div className="navbar__right">
          <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            <li><a href="#hero" onClick={handleNavClick} className="navbar__link--active">Hem</a></li>
            <li><a href="#about" onClick={handleNavClick}>Om mig</a></li>
            <li><a href="#services" onClick={handleNavClick}>Tjänster</a></li>
            <li><a href="#contact" onClick={handleNavClick}>Kontakt</a></li>
          </ul>
          <button
            className={`navbar__toggle ${menuOpen ? 'navbar__toggle--open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
